<template>
  <span class="dmh-wrap">
    <b-button size="sm" variant="outline-secondary"
              title="How to use the Driver Manager Dashboard" aria-label="Help" @click="show_help = true">
      <i class="fa fa-info-circle"></i>
    </b-button>

    <b-modal v-model="show_help" title="Using the Driver Manager Dashboard" size="lg" ok-only scrollable>
      <div class="dmh-body">
        <h4>What this page is</h4>
        <p>
          The fleet-wide view. Every other Driver Manager page narrows to a driver or a
          question; this one answers &ldquo;how is the roster doing overall, and is it moving?&rdquo;
        </p>

        <hr/>

        <h4>The three tabs</h4>
        <ul>
          <li>
            <b>Roster Overview</b> &mdash; the shape of the fleet right now. Where scores cluster,
            how the tiers split, and how the miles divide between them.
          </li>
          <li>
            <b>Flagged Drivers</b> &mdash; who crossed a threshold this period, and on which
            metric. This is the same logic the Coaching Portal&rsquo;s flagged panel uses, so the
            two always agree.
          </li>
          <li>
            <b>Trends</b> &mdash; the same numbers over time, period by period or month by month
            depending on how long the range is. A single period tells you
            where you are; this tells you which way you are going.
          </li>
        </ul>

        <hr/>

        <h4>Combined score and tiers</h4>
        <p>
          <b>Combined score</b> is a weighted blend of the KPIs &mdash; safety score, idling,
          speeding, DVIRs / (bus days × 2) and the rest. The weights are yours, not ours: set them under
          the <b>Settings</b> button in this header, and every page in Driver Manager follows.
        </p>
        <p>
          <b>Tiers</b> (Elite / Solid / Fair / High Risk) are bands on that score, and their
          boundaries are configurable in the same place. <b>Insufficient Data</b> is not a
          judgement &mdash; it means too few miles or bus days in the period to score anyone
          fairly, so those drivers sit out of rankings rather than scoring badly.
        </p>

        <hr/>

        <h4>The date range</h4>
        <p>
          Scores are published in periods of about five days, each one five days after it ends,
          once your telematics provider's review window has closed. The range ends on the latest
          published period, so it never includes days that are still settling: a half-finished
          period would read as a drop in mileage. The <b>1m</b>, <b>3m</b>, <b>6m</b> and
          <b>12m</b> chips count back from there, and the date pickers show exactly the days being
          scored.
          Pick your own start and end in the pickers for any range up to a year.
        </p>

        <hr/>

        <h4>Where to go next</h4>
        <ul>
          <li><b>Roster List</b> &mdash; the same drivers as a sortable table, one row each.</li>
          <li><b>Individual Driver</b> &mdash; one driver's full profile, with a PDF export.</li>
          <li><b>Compare</b> &mdash; several drivers side by side on the same metrics.</li>
          <li><b>Risk Matrix</b> &mdash; whether the miles are going to the right drivers.</li>
        </ul>
      </div>
    </b-modal>
  </span>
</template>

<script>
export default {
  name: 'driver_manager_dashboard_help',
  data() {
    return { show_help: false }
  },
}
</script>

<style scoped>
.dmh-body h4 { font-size: 1.05rem; margin-top: 4px; }
.dmh-body p, .dmh-body li { font-size: 0.95rem; }
.dmh-body li { margin-bottom: 6px; }
</style>
